// hooks/useLocale.js
import { useRouter } from "next/router";

export const useLocale = () => {
  const { locale } = useRouter();

  return locale === "default" ? process.env.NEXT_PUBLIC_DEFAULT_LOCALE : locale;
};
